




import Credentials from '@/models/Credentials';

export default {
  name: 'BypassLogin',
  methods: {
    bypassLogin() {
      // @ts-ignore
      this.$store.commit('login', new Credentials('Icariion', ''));
      // @ts-ignore
      this.$router.push('/');
    },
  },
  mounted() {
    // @ts-ignore
    this.bypassLogin();
  },
};
